import regex from "../../regex";

const validateGeoreferenziazione = (data) => {
  let issues = [];
  if(!data["comuneId"]) issues.push("É necessario specificare il comune o il sito di riferimento");
  if(!data["tipo"]) issues.push("É necessario specificare il tipo di layer");
  if(!data["valore"]) issues.push(`É necessario specificare il valoer del campo ${data.chiave}`);
  return issues;
}

export default validateGeoreferenziazione;
